export class BaseModel {
  toPlainObject(): Object {
    return Object.assign({}, this)
  }
}
